import { jwtDecode  } from "../helpers/token-utils";

export class ErrorAuth extends Error {}

class Auth {

  public getToken(): string | null {
    return localStorage.getItem("token");
  }

  async refreshToken(token?: string) {
    return await fetch(`${process.env.REACT_APP_MCA_URL}mca/api/v1/refreshToken`, {
      headers : {
        "x-token" : token ?? this.getToken(),
      } as HeadersInit,
      "method": "POST",
    }).then((response) => {
      if (!response.ok) {
        window.location.href = `${process.env.REACT_APP_MCA_URL}`;
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then((data) => {
      const {user, exp} = jwtDecode (data.token);
      localStorage.setItem('token', data.token);
      sessionStorage.setItem("user",  JSON.stringify(user));
      sessionStorage.setItem("exp",  JSON.stringify(exp));
      return {response: {token: data.token, exp}};
    })
    .catch((error) => {
      this.signOut()
      return { error };
    });
    }

  signOut(url?: string | undefined) {
    localStorage.removeItem("token");
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("exp");
    window.location.href = `${url ?? process.env.REACT_APP_MCA_URL}`;
  }
}

const auth = new Auth();
export default auth;
